import clsx from "clsx";
import React, { FunctionComponent } from "react";

import SubscribeNav from "@ui/components/navigation/Navigation/components/PrimaryNavigation/components/PrimaryNavigationStandard/components/SubscribeNav/SubscribeNav";
import { srOnly } from "@ui/shared-styles/accessibility.css";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

import * as styles from "./PrimaryNavigationMobile.css";

export interface RightMenuButtonsMobileProps {
  monochrome?: boolean;
}

interface Props {
  Logo: FunctionComponent<{ className?: string }>;
  cta: React.ReactElement | null;
  rightMenuButtons: React.FunctionComponent<RightMenuButtonsMobileProps>;
  monochrome?: boolean;
}

const PrimaryNavigationMobile: FunctionComponent<Props> = ({
  Logo,
  rightMenuButtons: RightMenuButtons,
  monochrome,
}) => {
  const analytics = useAnalytics();

  const handleLogoClick = () =>
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "front page" },
    });

  const getSubscribeUrl = () => {
    const returnPath = encodeURIComponent(window.location.pathname);
    return `/support-membership?itm_campaign=top-nav-bam-button&itm_medium=site&itm_source=navigation&returnPath=${returnPath}`;
  };

  return (
    <div
      className={clsx(
        monochrome && styles.containerMonochrome,
        styles.container,
      )}
    >
      <div className={styles.innerContainer}>
        <div className={clsx(styles.logoContainer)}>
          <a href="/" onClick={handleLogoClick}>
            <span className={srOnly}>The homepage</span>
            <Logo
              className={clsx(styles.logo, monochrome && styles.monochrome)}
            />
          </a>
        </div>
        <div className={styles.buttonsContainer}>
          <SubscribeNav
            subscribeText="Become a Member"
            getSubscribeUrl={getSubscribeUrl}
            signInText="Sign In"
            hideAccountLink
          />
          <div className={styles.buttonsInnerContainer}>
            <RightMenuButtons monochrome={monochrome} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrimaryNavigationMobile;
